import { render, staticRenderFns } from "./TrsaccRsultInqRpt2.vue?vue&type=template&id=50f9aea8"
import script from "./TrsaccRsultInqRpt2.vue?vue&type=script&lang=js"
export * from "./TrsaccRsultInqRpt2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f9aea8')) {
      api.createRecord('50f9aea8', component.options)
    } else {
      api.reload('50f9aea8', component.options)
    }
    module.hot.accept("./TrsaccRsultInqRpt2.vue?vue&type=template&id=50f9aea8", function () {
      api.rerender('50f9aea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/transfer/TrsaccRsultInqRpt2.vue"
export default component.exports